import React from "react";
import PropTypes from "prop-types";
import styles from "./StatusRadioButton.module.css";
import classNames from "classnames";

/**
 * Interactive component. A radio button styled as a button that determines a current feed category status.
 */
export function StatusRadioButton({
  icon,
  value,
  currentStatus,
  setCurrentStatus,
  color,
}) {
  return (
    <label htmlFor={value} onClick={setCurrentStatus}>
      <input
        value={value}
        type="radio"
        hidden
        checked={currentStatus === value}
        onChange={() => setCurrentStatus(value)} // Fix index warnings for checked prop without an onChange handler
      />
      <span
        className={classNames(styles.button, {
          [styles.active]: currentStatus === value,
          [styles.blue]: color === "blue",
          [styles.green]: color === "green",
          [styles.red]: color === "red",
        })}
      >
        {icon && icon}
        {value}
      </span>
    </label>
  );
}

StatusRadioButton.propTypes = {
  /**
   * An optional icon or image tag for the label.
   */
  icon: PropTypes.element,
  /**
   * The value/label of the radio button.
   */
  value: PropTypes.string,
  /**
   * The value of the currently selected status.
   */
  currentStatus: PropTypes.string,
  /**
   * Function that fires when clicked.
   * Takes the value as a parameter.
   */
  setCurrentStatus: PropTypes.func,
  /**
   * String that determines the color of the radio button when selected.
   */
  color: PropTypes.oneOf(["blue", "green", "red"]),
};
